import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lumiron-list',
  templateUrl: 'list.component.html',
  styleUrl: './list.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class ListComponent {}
